import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Database } from 'lucide-react';
import { databasesApi } from '../services/api';

const DatabasePickerPage = () => {
  const navigate = useNavigate();
  const [databases, setDatabases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    databasesApi.getAvailable()
      .then(res => setDatabases(res.data || []))
      .catch(() => {
        setDatabases([
          { displayName: 'GWA', description: 'Global Wafers', iconUrl: null },
          { displayName: 'GF', description: 'GlobalFoundries', iconUrl: null },
          { displayName: 'PNA', description: 'Panasonic', iconUrl: null }
        ]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (db) => {
    const slug = (db.displayName || db.name).toLowerCase();
    localStorage.setItem('pmd-selected-db-slug', slug);
    navigate(`/${slug}/`);
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--color-bg-page, #f5f5f5)',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '2.5rem',
        maxWidth: '560px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Database size={48} style={{ color: 'var(--color-primary, #2563eb)', marginBottom: '1rem' }} />
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.5rem', color: 'var(--color-text-primary, #1e293b)' }}>
          Select a Database
        </h1>
        <p style={{ color: 'var(--color-text-secondary, #64748b)', marginBottom: '1.5rem', fontSize: '0.875rem' }}>
          Choose a project database to get started.
        </p>

        {loading ? (
          <p style={{ color: 'var(--color-text-secondary, #64748b)' }}>Loading...</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {databases.map(db => {
              const name = db.displayName || db.name;
              return (
                <button
                  key={db.id || name}
                  onClick={() => handleSelect(db)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    padding: '1rem 1.25rem',
                    background: 'var(--color-bg-white, white)',
                    border: '1px solid var(--color-border, #e2e8f0)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'border-color 0.15s, box-shadow 0.15s'
                  }}
                  onMouseOver={e => { e.currentTarget.style.borderColor = 'var(--color-primary, #2563eb)'; e.currentTarget.style.boxShadow = '0 0 0 1px var(--color-primary, #2563eb)'; }}
                  onMouseOut={e => { e.currentTarget.style.borderColor = 'var(--color-border, #e2e8f0)'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                  {db.iconUrl && (
                    <img src={db.iconUrl} alt="" style={{ width: 32, height: 32, borderRadius: 4, objectFit: 'contain' }} />
                  )}
                  <div>
                    <div style={{ fontWeight: 600, fontSize: '0.95rem', color: 'var(--color-text-primary, #1e293b)' }}>{name}</div>
                    {db.description && (
                      <div style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary, #64748b)', marginTop: '2px' }}>{db.description}</div>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default DatabasePickerPage;
